export class TSRException extends Error {
  constructor(
    public readonly res: { status: number; headers: Headers; body: unknown },
  ) {
    super(`Failed API call (Status ${res.status})`);
  }
}
